"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var Nav_1 = __importDefault(require("./Nav"));
var TopBar_1 = __importDefault(require("./top-bar/TopBar"));
var navState_1 = require("../contexts/navState");
var use_nav_state_1 = require("hooks/use-nav-state");
var use_stores_1 = require("hooks/use-stores");
var Products_1 = __importDefault(require("./products/Products"));
var CreateProduct_1 = __importDefault(require("./products/create-product/CreateProduct"));
var EditProduct_1 = __importDefault(require("./products/edit-product/EditProduct"));
var Orders_1 = __importDefault(require("./orders/Orders"));
var ProductSpecifications_1 = __importDefault(require("./products/product-specifications/ProductSpecifications"));
var Logout_1 = __importDefault(require("./Logout"));
var CreateProductSpecification_1 = __importDefault(require("./products/product-specifications/create-product-specification/CreateProductSpecification"));
var ProductCategories_1 = __importDefault(require("./products/product-categories/ProductCategories"));
var logo_white_svg_1 = __importDefault(require("res/img/logo-white.svg"));
var CreateProductCategory_1 = __importDefault(require("./products/product-categories/create-product-category/CreateProductCategory"));
var EditProductCategory_1 = __importDefault(require("./products/product-categories/edit-product-category/EditProductCategory"));
var EditProductSpecification_1 = __importDefault(require("./products/product-specifications/edit-product-specification/EditProductSpecification"));
var ProductOptions_1 = __importDefault(require("./products/product-options/ProductOptions"));
var CreateProductOption_1 = __importDefault(require("./products/product-options/create-product-option/CreateProductOption"));
var EditProductOption_1 = __importDefault(require("./products/product-options/edit-product-option/EditProductOption"));
var SettingsPage_1 = __importDefault(require("./settings/SettingsPage"));
var Profile_1 = __importDefault(require("./profile/Profile"));
var UserStore_1 = require("../stores/UserStore");
var ViewOrder_1 = __importDefault(require("./orders/view-order/ViewOrder"));
var ProductSubCategories_1 = __importDefault(require("./products/product-sub-categories/ProductSubCategories"));
var EditProductSubCategory_1 = __importDefault(require("./products/product-sub-categories/edit-product-sub-category/EditProductSubCategory"));
var CreateProductSubCategory_1 = __importDefault(require("./products/product-sub-categories/create-product-sub-category/CreateProductSubCategory"));
var DeliveryCosts_1 = __importDefault(require("./delivery-costs/DeliveryCosts"));
var CreateDeliveryCost_1 = __importDefault(require("./delivery-costs/create-delivery-cost/CreateDeliveryCost"));
var EditDeliveryCost_1 = __importDefault(require("./delivery-costs/edit-delivery-cost/EditDeliveryCost"));
var CustomerAccounts_1 = __importDefault(require("./customer-accounts/CustomerAccounts"));
var CreateCustomerAccount_1 = __importDefault(require("./customer-accounts/create-customer-account/CreateCustomerAccount"));
var EditCustomerAccounts_1 = __importDefault(require("./customer-accounts/edit-customer-account/EditCustomerAccounts"));
var Root = mobx_react_1.observer(function () {
    var _a = react_1.useState(false), loaded = _a[0], setLoaded = _a[1];
    var location = react_router_dom_1.useLocation();
    var history = react_router_dom_1.useHistory();
    var navState = use_nav_state_1.useNavState();
    var userStore = use_stores_1.useStores().userStore;
    var search = location.search;
    var fromLogin = new URLSearchParams(search).get('login');
    var loginTimeout = react_1.useRef(null);
    var loadedTimeout = react_1.useRef(null);
    var zoom, theme;
    if (userStore.data) {
        zoom = userStore.data.settings.generalSettings.zoom;
        theme = userStore.data.settings.generalSettings.theme;
    }
    react_1.useEffect(function () {
        if (fromLogin !== null) {
            clearTimeout(loginTimeout.current);
            loginTimeout.current = setTimeout(function () {
                history.replace("/");
            }, 1500);
        }
        clearTimeout(loadedTimeout.current);
        loadedTimeout.current = setTimeout(function () {
            setLoaded(true);
        }, 1200);
        return function () {
            clearTimeout(loginTimeout.current);
        };
    }, []);
    react_1.useEffect(function () {
        if (userStore.data.databaseConnection === UserStore_1.CODA) {
            if (location.pathname === '/') {
                history.replace('/products');
            }
        }
    }, [location.pathname]);
    react_1.useEffect(function () {
        document.documentElement.setAttribute('data-zoom', zoom.toString());
    }, [zoom]);
    var toggleHandler = function () {
        navState.saveState(navState.state === navState_1.NavState.NOT_COLLAPSED ?
            navState_1.NavState.COLLAPSED :
            navState_1.NavState.NOT_COLLAPSED);
    };
    return (react_1.default.createElement("div", { className: "root flex flex-row", "data-loaded": loaded, "data-light-theme": theme === UserStore_1.Themes.LIGHT },
        react_1.default.createElement(Nav_1.default, { collapsed: navState.state, onCollapseToggle: toggleHandler }),
        react_1.default.createElement("div", { className: "root__main flex flex-column", "data-nav-collapsed": navState.state === navState_1.NavState.COLLAPSED },
            react_1.default.createElement(TopBar_1.default, { name: userStore.data && userStore.data.firstName || '' }),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/categories', component: ProductCategories_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/sub-categories', component: ProductSubCategories_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/specifications/edit/:id', component: EditProductSpecification_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/specifications', component: ProductSpecifications_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/options/edit/:id', component: EditProductOption_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/options', component: ProductOptions_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products/edit/:id', component: EditProduct_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/products', component: Products_1.default })),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/specifications/create', component: CreateProductSpecification_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/options/create', component: CreateProductOption_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/sub-categories/edit/:id', component: EditProductSubCategory_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/sub-categories/create', component: CreateProductSubCategory_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/categories/edit/:id', component: EditProductCategory_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/categories/create', component: CreateProductCategory_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/products/create', component: CreateProduct_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/settings', component: SettingsPage_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/profile', component: Profile_1.default }),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/orders/:id', component: ViewOrder_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/orders', component: Orders_1.default })),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/delivery-costs/edit/:id', component: EditDeliveryCost_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/delivery-costs', component: DeliveryCosts_1.default })),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/delivery-costs/create', component: CreateDeliveryCost_1.default }),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: '/customer-accounts/edit/:id', component: EditCustomerAccounts_1.default }),
                react_1.default.createElement(react_router_dom_1.Route, { path: '/customer-accounts', component: CustomerAccounts_1.default })),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/customer-accounts/create', component: CreateCustomerAccount_1.default }),
            react_1.default.createElement(react_router_dom_1.Route, { path: '/logout', component: Logout_1.default })),
        fromLogin === null &&
            react_1.default.createElement("div", { className: 'root-logo flex flex-column flex-center' },
                react_1.default.createElement("img", { src: logo_white_svg_1.default, alt: 'RWD' }))));
});
exports.default = Root;
